<div class="d-flex flex-auto justify-content-end measure-setting-filter topic-insights-container" *ngIf="!isExportingPdfReport && !haveNoData">
  <achoo-filter-box [options]="allTopics"
                    name="industry"
                    [multiple]="true"
                    [(model)]="selectedTopics"
                    (selectEvent)="filterTopics($event)">
  </achoo-filter-box>
</div>
<div class="topic-drill-down-container" *ngIf="!haveNoData">
  <list-gauge-circle-chart [charts]="activeCharts"
                           [titlePosition]="'top'"
                           [showReachLabel]="true"
                           [fixedLineColor]="topicChartColor">
  </list-gauge-circle-chart>
</div>
<div *ngIf="haveNoData" class="message">
  <span>{{'measure.noData' | translate}}</span>
</div>



// WEBPACK FOOTER //
// ./src/app/main/measure/topic-drill-down/topic-drill-down.component.html